module.exports = __webpack_public_path__ + "static/media/carrier.ebb04563.png";